// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProfileCard.css */
/* Uses utilities: .action-button-focus, .btn-primary, .flex-column-center, .text-truncate, .text-center, .text-wrap-anywhere, .section-centered, .btn-transparent */

.profileCard {
  /* Component container */
}

.name {
  font-size: var(--font-size-xl);
  font-weight: 700;
  line-height: var(--line-height-tight);
  text-decoration: underline;
  text-underline-offset: 0.2em;
  margin: 0;
  letter-spacing: var(--letter-spacing-wide);
}

.profile__actions {
  color: var(--color-text-secondary);
  font-size: var(--font-size-base, 1rem);
  margin-bottom: var(--spacing-xs);
}

.buttonSubSection {
  width: 100%;
  min-width: 0;
  display: grid;
}

.buttonSubSection button {
  width: 100%;
  min-width: 0;
}

/* Ensure prompt inputs stretch to fit their container */
.add-friend-button-container input[type="text"] {
  width: 100%;
  box-sizing: border-box;
}

.profile__qr-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  /* OLD color: var(--color-text-secondary);
  font-size: 1em;
  margin-bottom: var(--spacing-xs); */
}

.details {
  color: var(--color-text-muted);
  font-size: var(--font-size-base);
  line-height: var(--line-height-base);
  max-width: 45ch;
  margin-left: auto;
  margin-right: auto;
}

/* ProfileCard styles as regular CSS */
.profile-card {
  border: 1px solid #ccc;
  padding: 16px;
  background: white;
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/ProfileCard.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB,oKAAoK;;AAEpK;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;EAC1B,4BAA4B;EAC5B,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;AACnB","sourcesContent":["/* ProfileCard.css */\n/* Uses utilities: .action-button-focus, .btn-primary, .flex-column-center, .text-truncate, .text-center, .text-wrap-anywhere, .section-centered, .btn-transparent */\n\n.profileCard {\n  /* Component container */\n}\n\n.name {\n  font-size: var(--font-size-xl);\n  font-weight: 700;\n  line-height: var(--line-height-tight);\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n  margin: 0;\n  letter-spacing: var(--letter-spacing-wide);\n}\n\n.profile__actions {\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-base, 1rem);\n  margin-bottom: var(--spacing-xs);\n}\n\n.buttonSubSection {\n  width: 100%;\n  min-width: 0;\n  display: grid;\n}\n\n.buttonSubSection button {\n  width: 100%;\n  min-width: 0;\n}\n\n/* Ensure prompt inputs stretch to fit their container */\n.add-friend-button-container input[type=\"text\"] {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.profile__qr-code {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  align-self: stretch;\n  /* OLD color: var(--color-text-secondary);\n  font-size: 1em;\n  margin-bottom: var(--spacing-xs); */\n}\n\n.details {\n  color: var(--color-text-muted);\n  font-size: var(--font-size-base);\n  line-height: var(--line-height-base);\n  max-width: 45ch;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* ProfileCard styles as regular CSS */\n.profile-card {\n  border: 1px solid #ccc;\n  padding: 16px;\n  background: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
